import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LandingSeoService } from './services/landing-seo.service';

/**
 * Componente raíz de la feature. Usa ViewEncapsulation.None a propósito: es el único
 * punto donde se importa styles/landing-inversores.scss (design tokens + utilidades
 * BEM compartidas: __button, __card, __container...). Al desactivar la encapsulación
 * de Angular en ESTE componente, esas reglas dejan de llevar el atributo de scoping
 * de Angular y quedan disponibles para los componentes hijos (que sí mantienen su
 * encapsulación normal para sus propios estilos). Esto NO relaja el aislamiento: cada
 * selector de styles/landing-inversores.scss está anidado bajo `.landing-inversores`,
 * así que sigue sin poder afectar a nada fuera de ese contenedor raíz.
 */
@Component({
  selector: 'landing-inversores-root',
  templateUrl: './landing-inversores.component.html',
  styleUrls: ['./landing-inversores.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LandingInversoresComponent implements OnInit {
  constructor(private readonly seo: LandingSeoService) {}

  ngOnInit(): void {
    this.seo.apply({
      title: 'Inviertis — Invierte en pisos ya alquilados desde 60.000€',
      description:
        'Inviertis selecciona pisos ya alquilados con inquilinos solventes y contrato firmado. Rentabilidad inmediata del 6% al 11% en toda España. Oportunidades en exclusiva.',
      ogTitle: 'Inviertis — Inversión inmobiliaria con rentabilidad desde el primer día',
      ogDescription:
        'Pisos alquilados, inquilinos verificados y rentabilidad inmediata. +20.000 inversores confían en Inviertis.',
    });
  }
}
